export default __webpack_public_path__ + "static/media/timi.7fb1846e.png";